import { Injectable, computed, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { OrdersService } from './orders.service';

@Injectable()
export class OrderSelectionService {
  private ordersService = inject(OrdersService);

  private router = inject(Router);
  private route = inject(ActivatedRoute);

  paramsChanged$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => {
      let current = this.route.root;
      let params = {};
      while (current.firstChild) {
        current = current.firstChild;
        params = { ...params, ...current.snapshot.params };
      }
      return {
        orderId: params['orderId'],
        orderItemId: params['orderItemId'],
        orderItemConfigurationId: params['orderItemConfigurationId'],
      };
    }),
  );
  readonly selectedOrderId = toSignal(this.paramsChanged$.pipe(map((params) => params.orderId)));
  private selectedOrderItemId = toSignal(
    this.paramsChanged$.pipe(map((params) => params.orderItemId)),
  );
  readonly selectedOrderItemConfigurationId = toSignal(
    this.paramsChanged$.pipe(map((params) => params.orderItemConfigurationId)),
  );

  selectedOrder = computed(() =>
    this.selectedOrderId()
      ? this.ordersService.orders().find((order) => order.id === this.selectedOrderId())
      : null,
  );

  selectedOrderItem = computed(() =>
    this.selectedOrder()?.orderItems.find((item) => item.id === +this.selectedOrderItemId()),
  );

  selectedOrderItemConfiguration = computed(() =>
    this.selectedOrderItem()?.orderItemConfigurations.find(
      (config) => config.id === this.selectedOrderItemConfigurationId(),
    ),
  );

  constructor() {
    // reducers
    this.paramsChanged$
      .pipe(
        takeUntilDestroyed(),
        map((params) => params.orderId),
        filter(Boolean),
      )
      .subscribe((orderId) => this.ordersService.selectedOrderId$.next(orderId));
  }
}
